import styled from '@/styles';

export const ChipFilterButton = styled('button', {
  borderRadius: 999,
  border: '1px solid $colors$neutralLightest',
  background: '#FFFFFF',
  color: '$colors$textDefault',
  padding: '4px 10px',
  cursor: 'pointer',
  variants: {
    active: {
      true: {
        background: '$colors$textDefault',
        color: '#FFFFFF',
        borderColor: '$colors$textDefault',
      },
    },
  },
});

export const SpinnerWrapper = styled('div', {
  display: 'inline-flex',
  gap: 8,
  alignItems: 'center',
});

export const StatusBadgePill = styled('span', {
  display: 'inline-flex',
  borderRadius: 999,
  background: '$colors$neutralGhost',
  color: '$colors$textLight',
  fontSize: 12,
  padding: '2px 8px',
});

export const ProgressDots = styled('div', {
  display: 'flex',
  gap: 8,
  marginBottom: 16,
});

export const ProgressDot = styled('div', {
  width: 10,
  height: 10,
  borderRadius: 999,
  background: '$colors$neutralLightest',
  variants: {
    active: {
      true: {
        background: '$colors$textDefault',
      },
    },
  },
});
